import cn from "classnames";

import { SwitchProps } from "./Switch.types";

import styles from "./Switch.module.scss";

const Switch = ({ label, checked, disabled, ...props }: SwitchProps) => {
  return (
    <div className={styles.switch}>
      {label ? <p className={styles.switch__label}>{label}</p> : null}
      <label className={styles.switch__container}>
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          {...props}
        />
        <span
          className={cn(styles.switch__slider, {
            [styles.switch__slider__disabled]: disabled
          })}
        />
      </label>
    </div>
  );
};

export default Switch;
